import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import SettingsPageLayout from './SettingsPageLayout';
import TuneIcon from '@mui/icons-material/Tune';
import PersonIcon from '@mui/icons-material/Person';

const CustomFields = () => (
  <SettingsPageLayout
    title="Custom Fields"
    description="Create and manage custom fields for clients and contacts to capture firm-specific data."
  >
    <Paper
      variant="outlined"
      sx={{
        p: 5,
        borderRadius: 3,
        border: '1px dashed',
        borderColor: 'divider',
        bgcolor: 'background.default',
        textAlign: 'center',
        boxShadow: 'none',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 3, flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
          <PersonIcon fontSize="small" />
          <Typography variant="body2" sx={{ fontSize: 14 }}>Client fields</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary' }}>
          <TuneIcon fontSize="small" />
          <Typography variant="body2" sx={{ fontSize: 14 }}>Field types</Typography>
        </Box>
      </Box>
      <Typography variant="body1" sx={{ fontSize: 15, color: 'text.secondary', lineHeight: 1.6 }}>
        Coming soon. Add custom fields such as industry, referral source, or internal notes.
      </Typography>
    </Paper>
  </SettingsPageLayout>
);

export default CustomFields;
